'use client'
import classnames from 'classnames'
import { Button, If } from '@/components'

import styles from './styles.module.scss'
import Image from 'next/image'
import { useState } from 'react'

import { formattedValueToCurrency } from '@/utils/formatters/formattedValueToCurrency'

const Card = ({
  plan,
  submitPlan,
  isLoading,
  highlightText = '',
  disclaimer = '',
  priceComponent = null,
  ctaText = 'COMEÇAR AGORA',
  secondVariant,
  variant = 'default'
}) => {
  const [isSubmitBtn, setIsSubmitBtn] = useState(false)

  const installmentQuantity = !!plan?.installmentCount
    ? `${plan?.installmentCount}x`
    : ''

  return (
    <div
      className={classnames(styles.cardPlan, {
        [`${styles.cardPlanActived}`]: !!plan?.recommended,
        [`${styles.cardPlanLoading}`]: isLoading,
        [`${styles[`cardPlan--${variant}`]}`]: variant
      })}
    >
      <If
        condition={plan?.recommended}
        renderIf={<div className={styles.highlight}>{highlightText}</div>}
      />

      <div className={styles.content}>
        {plan.off && (
          <div className={styles.off}>
            <Image src={plan.off} alt={plan.name} width={42} height={42} />
          </div>
        )}

        <p className={styles.title}>Plano</p>
        <h3 className={styles.name}>{plan?.planType}</h3>

        {priceComponent ? (
          priceComponent
        ) : (
          <p className={styles.value}>
            <span className={styles.currency}>
              {installmentQuantity}
              <br />
              R$
            </span>
            <span className={styles.price}>
              {formattedValueToCurrency(
                plan?.installmentAmount.toFixed(2),
                'BRL',
                false
              )}
            </span>
          </p>
        )}

        <Button
          id={`btn-plan-${plan?.id}`}
          variant={variant === 'default' ? 'secondary' : 'yellow'}
          size="small"
          disabled={isSubmitBtn}
          className={styles.btn}
          textVariant={secondVariant}
          onClick={() => {
            setIsSubmitBtn(true)
            submitPlan(plan)
          }}
        >
          {ctaText}
        </Button>

        <p className={styles.cancel}>{disclaimer}</p>
      </div>
    </div>
  )
}

export default Card
